'use client';

import { c as _c } from "react/compiler-runtime";
import { FeatherArrowRight, FeatherChevronLeft } from '@subframe/core';
import { Button } from '@/shared/components/ui';
interface WizardFooterProps {
  onVoltar: () => void;
  onAvancar: () => void;
  avancarLabel?: string;
  avancarDisabled?: boolean;
}
export const WizardFooter = t0 => {
  const $ = _c(11);
  const {
    onVoltar,
    onAvancar,
    avancarLabel: t1,
    avancarDisabled: t2
  } = t0;
  const avancarLabel = t1 === undefined ? "Avan\xE7ar" : t1;
  const avancarDisabled = t2 === undefined ? false : t2;
  let t3;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = <FeatherChevronLeft />;
    $[0] = t3;
  } else {
    t3 = $[0];
  }
  let t4;
  if ($[1] !== onVoltar) {
    t4 = <Button variant="neutral-secondary" size="small" icon={t3} onClick={onVoltar}>Voltar</Button>;
    $[1] = onVoltar;
    $[2] = t4;
  } else {
    t4 = $[2];
  }
  let t5;
  if ($[3] === Symbol.for("react.memo_cache_sentinel")) {
    t5 = <FeatherArrowRight />;
    $[3] = t5;
  } else {
    t5 = $[3];
  }
  let t6;
  if ($[4] !== avancarDisabled || $[5] !== avancarLabel || $[6] !== onAvancar) {
    t6 = <Button size="small" iconRight={t5} disabled={avancarDisabled} onClick={onAvancar}>{avancarLabel}</Button>;
    $[4] = avancarDisabled;
    $[5] = avancarLabel;
    $[6] = onAvancar;
    $[7] = t6;
  } else {
    t6 = $[7];
  }
  let t7;
  if ($[8] !== t4 || $[9] !== t6) {
    t7 = <div className="flex items-center justify-between border-t border-solid border-neutral-200 px-6 py-6 md:px-20">{t4}{t6}</div>;
    $[8] = t4;
    $[9] = t6;
    $[10] = t7;
  } else {
    t7 = $[10];
  }
  return t7;
};